/** Timings are defined in milliseconds */
export interface ICoreTimings {
  /** Time defining how long bets are accepted by server  */
  bettingWindow: number;
  /** Time before the end of the betting window, when to notify player about bets being closed soon */
  bettingLastCall: number;
  /** A delay of messages for GameCommunicationController */
  gameCommunicationDelay: number;
  /** Video stream delay boundaries when summed with studio latency */
  videoDelayBoundaryMin: number;
  videoDelayBoundaryMax: number;
  /** Studio latency, time it takes to process the video and ready for delivery */
  studioLatency: number;
}

export const CoreDefaultTimings: ICoreTimings = {
  bettingWindow: 15_000,
  bettingLastCall: 5_000,
  gameCommunicationDelay: 2_000,
  videoDelayBoundaryMin: 2000,
  videoDelayBoundaryMax: 4_500,
  studioLatency: 1_000,
} as const;
